module.exports = __webpack_public_path__ + "media/images/konintodoke/check-icon-f9afc0b8718385aa0da77d44cb43dd63.png";